/*
Підключаєм тільки ті стилі, які будуть на всіх сторінках
*/

import 'normalize.css/normalize.css';
import 'simplebar/dist/simplebar.css';
import 'node-waves/dist/waves.css';
import '__scss/main.scss';

/*
Підключаєм тільки ті модулі, які беруть участь в логіці всіх сторінок
*/

import 'simplebar';
import tippy from 'tippy.js';
import mask from '__jsStatic/mask';

// header
import { successDropdown, userDropdown, menuOpen, menuProfileOpen } from '__jsStatic/_header';
import textarea from '__jsStatic/textarea';

import Waves from 'node-waves';

tippy('.tooltip', {
	placement: 'bottom',
	animation: 'scale',
	arrow:     true
});
/*
Визначення глобальних дефолтних налаштувань
*/

Waves.init();
userDropdown();
successDropdown();
menuOpen();
menuProfileOpen();
textarea();
mask();
